import React from 'react';
import { Col, Row } from 'antd';

import CvssScore from '@totem/components/software/cves/cvssScore';
import { NVDMetricsV4 } from '@totem/components/software/cves/types';
import { colorUnknown } from '@totem/components/software/cves/utilities';
import ValueBlock from '@totem/components/software/cves/valueBlock';
import { isNotNull } from '@totem/utilities/common';

import './cve.css';

type Props = {
  metricsV4: NVDMetricsV4;
  showType?: boolean;
};

const CvssMetricsV4Panel = ({ metricsV4, showType }: Props) => {
  const values = [
    [
      ['Attack Vector', metricsV4.cvssData.attackVector],
      ['Attack Complexity', metricsV4.cvssData.attackComplexity],
      ['Attack Requirements', metricsV4.cvssData.attackRequirements],
      ['Privileges Required', metricsV4.cvssData.privilegesRequired],
      ['User Interaction', metricsV4.cvssData.userInteraction],
    ],
    [
      ['Confidentiality Impact', metricsV4.cvssData.vulnConfidentialityImpact],
      ['Integrity Impact', metricsV4.cvssData.vulnIntegrityImpact],
      ['Availability Impact', metricsV4.cvssData.vulnAvailabilityImpact],
      ['Exploit Maturity', metricsV4.cvssData.exploitMaturity],
    ],
  ];

  return (
    <Row gutter={[20, 10]}>
      <Col span={8}>
        {isNotNull(showType) && showType && (
          <div styleName="type">{metricsV4.type}</div>
        )}
        <CvssScore
          title="CVSS v4.0"
          score={metricsV4.cvssData.baseScore}
          maxScore={10}
        />
      </Col>
      {values.map((column, columnIdx) => (
        <Col span={8} key={columnIdx}>
          {column
            .filter(([, value]) => isNotNull(value) && value !== '')
            .map(([title, value]) => (
              <ValueBlock
                key={title}
                title={title}
                value={value}
                valueColor={colorUnknown}
              />
            ))}
        </Col>
      ))}
    </Row>
  );
};

export default CvssMetricsV4Panel;
